import { lazy } from "react";


function load(code){
    switch (code) {
        case "notifications/list":
            return lazy(() => import("views/notifications/list"));
        default:
            return null;
    }
}
export default load;
